'use client';

import {createContext, useContext, useState, type ReactNode} from 'react';
import type {SubmissionFlowData} from 'iq-interview_experiences/types';

export interface FlowPrefill {
  data: Partial<SubmissionFlowData>;
  step: number;
}

export type CardStyle = 'full-bleed' | 'inset';

interface DevConfig {
  prefillFlowData: FlowPrefill | null;
  setPrefillFlowData: (data: FlowPrefill | null) => void;
  prefillEmail: string | null;
  setPrefillEmail: (email: string | null) => void;
  structuredQuestions: boolean;
  setStructuredQuestions: (v: boolean) => void;
  cardStyle: CardStyle;
  setCardStyle: (v: CardStyle) => void;
}

const DevConfigContext = createContext<DevConfig | null>(null);

export function DevConfigProvider({children}: {children: ReactNode}) {
  const [prefillFlowData, setPrefillFlowData] = useState<FlowPrefill | null>(null);
  const [prefillEmail, setPrefillEmail] = useState<string | null>(null);
  const [structuredQuestions, setStructuredQuestions] = useState(false);
  const [cardStyle, setCardStyle] = useState<CardStyle>('full-bleed');

  return (
    <DevConfigContext.Provider value={{prefillFlowData, setPrefillFlowData, prefillEmail, setPrefillEmail, structuredQuestions, setStructuredQuestions, cardStyle, setCardStyle}}>
      {children}
    </DevConfigContext.Provider>
  );
}

export function useDevConfig(): DevConfig {
  const ctx = useContext(DevConfigContext);
  if (!ctx) throw new Error('useDevConfig must be used inside DevConfigProvider');
  return ctx;
}
